import { useEffect, useState, useRef } from 'react';
import { Rocket, ArrowRight } from 'lucide-react';

const PREMIUM_ORBITS = ['meo', 'heo', 'molniya', 'tundra', 'graveyard', 'hohmann', 'lagrange'];

export default function UnlockPremium() {
  const [unlocked, setUnlocked] = useState(false);
  const hasUnlocked = useRef(false);

  useEffect(() => {
    // Only run once
    if (hasUnlocked.current) return;
    hasUnlocked.current = true;
    
    // Directly update localStorage to unlock premium
    try {
      const stored = localStorage.getItem('orbitops_progress');
      let progress = stored ? JSON.parse(stored) : {
        totalPoints: 0,
        unlockedOrbits: ['orbital_elements', 'leo'],
        completedLessons: [],
        quizScores: {},
        achievements: [],
        isPremium: false,
        sessionId: 'session_' + Math.random().toString(36).substring(2, 15),
        lastActive: new Date().toISOString(),
      };
      
      // Set premium and unlock all premium orbits
      progress.isPremium = true;
      progress.unlockedOrbits = [...new Set([...progress.unlockedOrbits, ...PREMIUM_ORBITS])];
      
      // Save immediately
      localStorage.setItem('orbitops_progress', JSON.stringify(progress));
      console.log('Premium unlocked! Progress:', progress);
      
      // Dispatch event for any listening components
      window.dispatchEvent(new Event('orbitops-progress-update'));
      
      setUnlocked(true);
    } catch (e) {
      console.error('Failed to unlock premium:', e);
    }
    
    // Use hard redirect to ensure fresh page load with new localStorage
    const timer = setTimeout(() => {
      window.location.href = '/learn';
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  const handleManualRedirect = () => {
    // Hard redirect to ensure fresh load
    window.location.href = '/learn';
  };

  return (
    <div style={{ minHeight: '100vh', background: '#030305', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="text-center animate-fadeIn">
        <div className="inline-flex items-center justify-center w-24 h-24 rounded-full mb-6" style={{ background: 'linear-gradient(135deg, rgba(0,255,148,0.2), rgba(0,240,255,0.1))', border: '2px solid rgba(0,255,148,0.5)' }}>
          <Rocket size={48} color="#00FF94" />
        </div>
        <h1 style={{ fontFamily: 'Rajdhani', fontSize: '36px', fontWeight: 700, color: '#00FF94', textTransform: 'uppercase', letterSpacing: '0.15em', marginBottom: '12px' }}>
          Premium Unlocked!
        </h1>
        <p style={{ fontFamily: 'Outfit', fontSize: '16px', color: 'rgba(255,255,255,0.6)', marginBottom: '24px' }}>
          You now have full access to all orbits and features.
        </p>
        
        {unlocked && (
          <button
            onClick={handleManualRedirect}
            data-testid="go-to-learn-btn"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl"
            style={{ 
              background: 'linear-gradient(135deg, #00FF94, #00F0FF)', 
              border: 'none', 
              cursor: 'pointer', 
              fontFamily: 'Rajdhani', 
              fontWeight: 700, 
              fontSize: '16px', 
              color: '#000', 
              textTransform: 'uppercase', 
              letterSpacing: '0.1em',
              boxShadow: '0 4px 20px rgba(0,255,148,0.3)'
            }}
          >
            Start Learning <ArrowRight size={20} />
          </button>
        )}
        
        <p style={{ fontFamily: 'JetBrains Mono', fontSize: '11px', color: 'rgba(255,255,255,0.3)', marginTop: '16px' }}>
          Auto-redirecting...
        </p>
      </div>
    </div>
  );
}
